export default "__VITE_ASSET__11a473a8__"